import { render, staticRenderFns } from "./DepartureManifest.vue?vue&type=template&id=d5080b82&"
import script from "./DepartureManifest.vue?vue&type=script&lang=js&"
export * from "./DepartureManifest.vue?vue&type=script&lang=js&"
import style0 from "./DepartureManifest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports